export default {
      id: "help-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#help",
      toString: function () {
        return this.url;
      }
    }